import { Typography } from "@mui/material";
import { Brand } from "entities/brands/types";
import { Page, PageModuleData } from "entities/pages/types";
import { ReactNode } from "react";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { COLOR_ALERT_TITLE, COLOR_BLACK } from "shared/theme/colors";
import { MoveOrDuplicateType } from "../../types";

export const createAlertMessage = (
  isSuccess: boolean,
  module: PageModuleData,
  targetBrandId: string,
  targetPageId: string,
  moveOrDuplicateType: MoveOrDuplicateType,
  brands: Brand[],
  pages: Page[],
): ReactNode => {
  const actionType =
    moveOrDuplicateType === MoveOrDuplicateType.Move ? "moved" : "duplicated";

  const failureOperation =
    moveOrDuplicateType === MoveOrDuplicateType.Move ? "Move" : "Duplication";

  const operationTitle = isSuccess
    ? `Module ${actionType} successfully`
    : `${failureOperation} failed`;

  const action = isSuccess ? "has been" : "could not be";

  return (
    <FlexColumn gap="0.25rem">
      <Typography variant="bodyLSemiBold" color={COLOR_ALERT_TITLE}>
        {operationTitle}
      </Typography>
      <Typography variant="bodyMRegular" color={COLOR_BLACK}>
        The module{" "}
        <Typography variant="bodyMSemiBold" color={COLOR_BLACK}>
          "{module.name}"
        </Typography>{" "}
        {action} {actionType} to{" "}
        <Typography
          variant="bodyMSemiBold"
          textTransform="capitalize"
          color={COLOR_BLACK}
        >
          [{brands.find((brand) => brand.id === targetBrandId)?.name ?? ""}]{" "}
          {">"} [{pages.find((page) => page.id === targetPageId)?.title ?? ""}]
        </Typography>
      </Typography>
    </FlexColumn>
  );
};
